/* Publish by EComposer at 2026-10-01 01:00:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-v6fndworrod"]=  window.__ectimmers["ecom-v6fndworrod"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-v6fndworrod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6fndworrod', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ukapz6ybmmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ukapz6ybmmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1bh3oc3hh2p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1bh3oc3hh2p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dk3d3kzy95p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dk3d3kzy95p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7h2og7bad66').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7h2og7bad66', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cctmkvztfav').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cctmkvztfav', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ouy52hei0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ouy52hei0g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0392fdd2rann').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0392fdd2rann', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3n1k55pzjgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3n1k55pzjgi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35w4sfwv9bu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35w4sfwv9bu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8gc4r0jkj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8gc4r0jkj5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ktohkm14h1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ktohkm14h1g', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-komu62f2ct"]=  window.__ectimmers["ecom-komu62f2ct"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-komu62f2ct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-komu62f2ct', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kdc3ejy73j"]=  window.__ectimmers["ecom-kdc3ejy73j"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-kdc3ejy73j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdc3ejy73j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhk7xirjspd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhk7xirjspd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxvg1yxzwui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxvg1yxzwui', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oc6ye1d18nj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oc6ye1d18nj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7dv9l6ma9le').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dv9l6ma9le', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-flnz9l2hxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-flnz9l2hxm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r27ji8utccf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r27ji8utccf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9scmklf1gs5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9scmklf1gs5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0d429k0r6j4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0d429k0r6j4n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hzlhfln5k8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hzlhfln5k8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i1bwy7v4x3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i1bwy7v4x3g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x95r5fppfo"]=  window.__ectimmers["ecom-x95r5fppfo"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-x95r5fppfo"]["5cq1mkvz6"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-x95r5fppfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x95r5fppfo', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            